import { Button } from "react-bootstrap";
import "./styles.css";

export const BackButton = ({ onClick, label }) => {
  return (
    <Button variant="link" size="sm" className="btnBack" onClick={onClick}>
      <span aria-hidden>←</span>
      <span className="btnBack__label">{label}</span>
    </Button>
  );
}
